export default "__VITE_ASSET__CiB5SJuu__"